module.exports = __webpack_public_path__ + "assets/img/sake-varietal.c571fa96.svg";